import React from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";

export default function TaskFormBack() {
  const history = useHistory();
  const params = useParams();
  const location = useLocation();

  const back = () => {
    const taskId = params?.taskId;
    const cameFromTaskList = location.state?.fromTaskList;
    if (taskId && cameFromTaskList) {
      // Came from task list - go back and open modal
      history.push("/tasks", { taskId: parseInt(taskId), openModal: true });
    } else {
      // Came from task edit or other page - just go back
      window.history.back();
    }
  };

  return (
    <div className="d-flex back justify-content-start align-items-center">
      <FluentUiIcon name={"ArrowLeftRegular"} color={"#0F6CBD"} size={20} />
      <div role="button" className="back-text" onClick={() => back()}>Back</div>
    </div>
  );
}